import { apiRequest } from '@/api/request.js'
import { PRODUCT_DETAIL_ROUTE } from '@/utils/routes.js'
export const listDistributionMessages = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/distribution_msg/page',
    method: 'GET'
  })
}
export const getDistributionMessage = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/distribution_msg',
    method: 'GET'
  })
}
export const getDistributionRecruitInfo = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/distribution_recruit/info',
    method: 'GET'
  })
}
export const getDistributionSettings = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/distribution_set/info',
    method: 'GET'
  })
}
export const listDistributionBindUsers = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/distribution_user_bind/bind_user_list',
    method: 'GET'
  })
}
export const getBoundDistributionUser = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/distribution_user_bind/get_bind_distribution_user',
    method: 'GET'
  })
}
export const getDistributionUserInfo = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/distribution_user/distribution_user_info',
    method: 'GET'
  })
}
export const getDistributionUserById = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/distribution_user/get_by_id',
    method: 'GET'
  })
}
export const listMyPromotionOrders = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/distribution_user_income/my_promotion_order',
    method: 'GET'
  })
}
export const listDistributionIncomeRecords = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/distribution_user_income/page',
    method: 'GET'
  })
}
export const getDistributionUserIncomeStatistics = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/distribution_user_income/statistics',
    method: 'GET'
  })
}
export const getDistributionWalletInfo = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/distribution_user_wallet',
    method: 'GET'
  })
}
export const getEnterprisePayById = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/enterprise_pay/get_by_id',
    method: 'GET'
  })
}
export const listComboPackages = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/ma/combo',
    method: 'GET'
  })
}
export const listComboProdSkuOptions = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/combo_prod_sku/comboSpuSkuList',
    method: 'POST'
  })
}
export const listGeneralCoupons = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/ma/coupon/general_coupon_list',
    method: 'GET'
  })
}
export const getCouponById = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/ma/coupon/get_by_coupon_id',
    method: 'GET'
  })
}
export const listCouponActivities = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/ma/coupon/get_coupon_page',
    method: 'GET'
  })
}
export const listShopOrProdCoupons = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/ma/coupon/get_shop_or_spu_coupon_list',
    method: 'GET'
  })
}
export const listCouponProdList = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/ma/coupon/get_spus_by_coupon_id',
    method: 'GET'
  })
}
export const getMyCouponCountByStatusOrType = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/my_coupon/get_my_coupons_status_or_type_count',
    method: 'GET'
  })
}
export const listMyCouponPage = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/my_coupon/get_page',
    method: 'GET'
  })
}
export const listDiscountActivities = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/ua/discount/get_discount_list',
    method: 'GET'
  })
}
export const getDiscountInfo = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/ua/discount/info',
    method: 'GET'
  })
}
export const listDiscountPage = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/ua/discount/list',
    method: 'GET'
  })
}
export const listDiscountProdPage = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/ua/discount/spu_page_by_discount_id',
    method: 'GET'
  })
}
export const getDistributionInvitationQrcode = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/ua/distribution_qrcode/invitation',
    method: 'GET'
  })
}
export const getDistributionInvitationQrcodeUrl = (distributionUserId, page = PRODUCT_DETAIL_ROUTE) => {
  return `${import.meta.env.VITE_APP_BASE_API}/mall4cloud_marketing/ua/distribution_qrcode/invitation?page=${page}&distributionUserId=${distributionUserId}`
}
export const checkDistributionProdState = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/ua/distribution_spu/is_state',
    method: 'GET'
  })
}
export const getLiveRoomInfo = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/ua/live_room/get_live_room_info',
    method: 'GET'
  })
}
export const getLiveRoomPullUrl = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/ua/live_room/get_pull_url',
    method: 'GET'
  })
}
export const getProdLiveRoomInfo = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/ua/live_room/get_spu_live_room_info',
    method: 'GET'
  })
}
export const listLiveExplainedProds = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/ua/live_room/live_explain_spu',
    method: 'GET'
  })
}
export const listLiveRoomPage = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/ua/live_room/page',
    method: 'GET'
  })
}
export const listLiveRoomProdPage = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/ua/live_room/page_living_room_prod',
    method: 'GET'
  })
}
export const registerDistributionUser = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/distribution_register/add_distribution_user',
    method: 'POST'
  })
}
export const bindDistributionUser = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/distribution_user_bind/bind_user',
    method: 'POST'
  })
}
export const applyDistributionWithdrawCash = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/distribution_withdraw_cash/apply',
    method: 'POST'
  })
}
export const getDistributionWithdrawCashTotal = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/distribution_withdraw_cash/total_withdraw_cash',
    method: 'GET'
  })
}
export const listDistributionWithdrawCashPage = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/distribution_withdraw_cash/page',
    method: 'GET'
  })
}
export const receiveMyCoupon = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_marketing/my_coupon/receive',
    method: 'POST'
  })
}
